import type { ContractTemplateType } from '@super-mega/server/contracts/contract'

export const CONTRACT_TEMPLATE_TYPES = {
  lease: { label: '租赁合同', color: 'blue' },
  service: { label: '服务合同', color: 'green' },
  housing_proof: { label: '房屋证明', color: 'purple' },
  supplement: { label: '补充协议', color: 'orange' },
  other: { label: '其他', color: 'default' }
} as const satisfies Record<ContractTemplateType, { label: string; color: string }>

export const CONTRACT_VARIABLE_TYPES = {
  text: '文本',
  date: '日期',
  money: '金额',
  number: '数字',
  address: '地址',
  boolean: '布尔值'
} as const

export const CONTRACT_TEMPLATE_VERSION_STATUS = {
  draft: { label: '草稿', color: 'warning' },
  published: { label: '已发布', color: 'success' },
  archived: { label: '已归档', color: 'default' }
} as const

export const CONTRACT_DOCUMENT_STATUS = {
  confirmed: { label: '已确认', color: 'processing' },
  effective: { label: '已生效', color: 'success' },
  voided: { label: '已作废', color: 'error' }
} as const
